import { useContext, useMemo } from 'react';

import CurrentUserContext from 'contexts/CurrentUserContext';
import DashboardGadgetsContext from 'contexts/DashboardGadgetsContext';
import ReportGadgetsContext from 'contexts/ReportGadgetsContext';
import useFilterInput from 'hooks/useFilterInput';

import getUsesGroupVsRemainderVis from './getUsesGroupVsRemainderVis';

const useIsInvalidFilterInput = (canvas: Canvas) => {
  const { isFleetOpsStaff } = useContext(CurrentUserContext);
  const { dashboardGadgetsLookup } = useContext(DashboardGadgetsContext);
  const { reportGadgetsLookup } = useContext(ReportGadgetsContext);
  const { lastDrilldown } = useFilterInput({ extractEntityFilter: true });

  const usesGroupVsRemainderVis = useMemo(
    () =>
      getUsesGroupVsRemainderVis({
        canvas,
        dashboardGadgetsLookup,
        reportGadgetsLookup,
      }),
    [canvas, dashboardGadgetsLookup, reportGadgetsLookup],
  );

  const invalidFilterInput = useMemo(() => {
    if (!usesGroupVsRemainderVis) return false;

    return (
      lastDrilldown?.wildcardFilters?.length || lastDrilldown?.ranges?.length
    );
  }, [
    lastDrilldown?.ranges?.length,
    lastDrilldown?.wildcardFilters?.length,
    usesGroupVsRemainderVis,
  ]);

  return invalidFilterInput && isFleetOpsStaff;
};

export default useIsInvalidFilterInput;
